import { useDispatch } from 'react-redux';
import {
  useAddFavouriteFarmMutation,
  useRemoveFavouriteFarmMutation,
} from '@/rtk/userPreferencesApi';
import { addSnackbar } from '@/reducers/snackbarSlice';
import { MAXIMUM_NUMBER_OF_FAVOURITE_FARMS_ERROR_MESSAGE } from './constants';
import { Icon } from '@/common/components';
import { Farm } from '@/rtk/farmsApi';
import { LelyButton } from '@/common/components';

type Props = {
  farm: Pick<Farm, 'id' | 'isFavourite'>;
  isMaxAmountReached?: boolean;
  isCompact?: true;
};

function FarmFavouriteActions({
  farm: { id, isFavourite },
  isMaxAmountReached,
  isCompact,
}: Props) {
  const dispatch = useDispatch();

  const [addFavourite] = useAddFavouriteFarmMutation();
  const [removeFavourite] = useRemoveFavouriteFarmMutation();

  const handleAction = () => {
    if (isFavourite) {
      removeFavourite(id);
    } else {
      if (isMaxAmountReached) {
        dispatch(
          addSnackbar({
            snackbar: {
              id: `${id}-error`,
              type: 'error',
              message: MAXIMUM_NUMBER_OF_FAVOURITE_FARMS_ERROR_MESSAGE,
              isOpen: true,
              durationInSeconds: 5,
            },
          }),
        );

        return;
      }

      addFavourite(id);
    }
  };

  const iconName = isFavourite
    ? 'lely-icon-star-filled'
    : 'lely-icon-star-empty';

  return (
    <LelyButton
      variant={isCompact ? 'tertiary' : 'secondary'}
      data-testid="favourite-farm-btn"
      dense
      square
      leadingIcon={iconName}
      onClick={(e) => {
        e.stopPropagation();
        handleAction();
      }}
    />
  );
}

export default FarmFavouriteActions;
